import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiServiceEnvironment, UiServiceWebSession } from '@drct-web-apps/ui-services';
import { ReplaySubject, takeUntil } from 'rxjs';



@Component({
  selector: 'ui-web-footer',
  templateUrl: './ui-web-footer.component.html',
  imports: [ RouterModule]
})
export class UiWebFooterComponent implements OnInit, OnDestroy {
  private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  public readonly env = inject(UiServiceEnvironment);
  public readonly webSession = inject(UiServiceWebSession);

  public year = "";
  public enquiry_email = "enquirydrct@gmail.com";

  ngOnInit(): void {
    this.setEnquiryEmailAndYear();
    this.webSession.sessionReady
                   .pipe(takeUntil(this.destroyed$))
                   .subscribe((ready: boolean) => {
                      if(ready) {
                        this.setEnquiryEmailAndYear();
                      }
                    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  
  private setEnquiryEmailAndYear(): void {
    this.year = this.webSession.webConfig?.year ?? (new Date()).getFullYear().toString();
    this.enquiry_email = this.webSession.webConfig?.enquiry_email ?? "enquirydrct@gmail.com";
  }
}
